import { render } from "./TeuteufGames.vue?vue&type=template&id=8ec01fe4&scoped=true"
import script from "./TeuteufGames.vue?vue&type=script&lang=js"
export * from "./TeuteufGames.vue?vue&type=script&lang=js"

import "./TeuteufGames.vue?vue&type=style&index=0&id=8ec01fe4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec01fe4"]])

export default __exports__